import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-property-stats',
  templateUrl: './property-stats.component.html',
  styleUrls: ['./property-stats.component.scss']
})
export class PropertyStatsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
